import { HS_upload } from './huoshanUpload';

tinymce.PluginManager.add('uploadImg', function (editor, url) {
    editor.ui.registry.addIcon(
        "img-icon",
        `<svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="design-iconfont"><mask id="aadw8ovei__v4urxv5dwa" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path fill="#D9D9D9" d="M0 0H24V24H0z"/></mask><g mask="url(#aadw8ovei__v4urxv5dwa)" stroke="#333" stroke-width="1.5"><path fill="none" d="M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke-linejoin="round"/><path fill="none" d="M9.75 8.25C9.75 9.07843 9.07843 9.75 8.25 9.75C7.42157 9.75 6.75 9.07843 6.75 8.25C6.75 7.42157 7.42157 6.75 8.25 6.75C9.07843 6.75 9.75 7.42157 9.75 8.25Z"/><path fill="none" d="M9.75 16.5C9.75 14.8431 8.40685 13.5 6.75 13.5C5.09315 13.5 3.75 14.8431 3.75 16.5"/><path fill="none" d="M9 21C9 14.3726 14.3726 9 21 9"/></g></svg>`
    );

    // 注册一个工具栏按钮名称
    editor.ui.registry.addButton('uploadImg', {
        icon: `img-icon`,
        tooltip: '插入图片',
        onAction: function () {
            window.postMessage("openInsertImg", "*");

            // let filetype = ".gif,.jpg,.jpeg,.png,.GIF,.JPG,.JPEG,.PNG,.img";
            // var input = document.createElement("input");
            // input.setAttribute("type", "file");
            // input.setAttribute("accept", filetype);
            // input.click();
            // input.onchange = function (e) {
            //     let file = this.files[0];
            //     HS_upload(file, (data) => {
            //         editor.insertContent('<p><img src="' + data.url + '" width="100%" height="auto" data-mce-src="' + data.url + '" data-mce-selected="1"></p>');
            //     },
            //         (error) => {
            //             console.log(error);
            //         }, (processPercent) => {
            //             console.log("processPercent:" + processPercent);
            //         })
            // };
        }
    });

    return {
        getMetadata: function () {
            return {
                //插件名和链接会显示在“帮助”→“插件”→“已安装的插件”中
                name: "",//插件名称
                url: "", //作者网址
            };
        }
    };
});